@let err = error();
@if (err) {
  <span>
    @if (err.messageKey) {
      {{ err.messageKey | translate }}
    } @else {
      {{
        'errors.validationErrors.' + err.key
          | translate: { val: err.value | validationError: err.key }
      }}
    }
  </span>
}
